import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FaEye, FaHeart, FaComment, FaTrash } from 'react-icons/fa';
import api from '../services/api';
import '../styles/StoryDetails.css';
import getBookCoverUrl from '../utils/getBookCoverUrl';

// StoryForm bileşeni, telif hakkı için sayısal ID'ler ile güncellendi.
const StoryForm = ({
  title,
  setTitle,
  description,
  setDescription,
  category,
  setCategory,
  isMatureContent,
  setIsMatureContent,
  copyright,
  setCopyright,
}) => (
  <div className="story-form">
    <div className="form-group">
      <label htmlFor="title">Başlık</label>
      <input
        id="title"
        type="text"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        placeholder="Hikaye başlığını girin"
        className="form-input"
      />
    </div>

    <div className="form-group">
      <label htmlFor="description">Açıklama</label>
      <textarea
        id="description"
        value={description}
        onChange={(e) => setDescription(e.target.value)}
        placeholder="Hikayen hakkında kısa bir açıklama yazın"
        className="form-textarea"
      />
    </div>

    <div className="form-group">
      <label htmlFor="category">Kategori</label>
      <select
        id="category"
        value={category}
        onChange={(e) => setCategory(e.target.value)}
        className="form-select"
      >
        <option value="">Bir kategori seçin</option>
        <option value="1">Aksiyon</option>
        <option value="2">Bilim Kurgu</option>
        <option value="3">Fantastik</option>
        <option value="4">Genel Kurgu</option>
        <option value="5">Genç Kurgu</option>
        <option value="6">Gerilim</option>
        <option value="7">Gizem</option>
        <option value="8">Hayran Kurgu</option>
        <option value="9">Klasikler</option>
        <option value="10">Korku</option>
        <option value="11">Kısa Hikaye</option>
        <option value="12">Macera</option>
        <option value="13">Mizah</option>
        <option value="14">Paranormal</option>
        <option value="15">Romantizm</option>
        <option value="16">Spiritüel</option>
        <option value="17">Tarihi Kurgu</option>
        <option value="18">Texting</option>
        <option value="19">Vampir</option>
        <option value="20">Şiir</option>
      </select>
    </div>

    <div className="form-group">
      <label htmlFor="mature-content">İçerik Türü</label>
      <select
        id="mature-content"
        value={isMatureContent ? 'true' : 'false'}
        onChange={(e) => setIsMatureContent(e.target.value === 'true')}
        className="form-select"
      >
        <option value="false">Genel İçerik</option>
        <option value="true">Yetişkin İçerik</option>
      </select>
    </div>

    <div className="form-group">
      <label htmlFor="copyright">Telif Hakkı</label>
      <select
        id="copyright"
        value={copyright}
        // DÜZELTME: Gelen string değeri sayıya çevirerek state'i güncelliyoruz.
        onChange={(e) => setCopyright(parseInt(e.target.value, 10))}
        className="form-select"
      >
        {/* DÜZELTME: Her option'a veritabanındaki ID'ye karşılık gelen sayısal bir value atandı. */}
        <option value="1">Telif Hakkı Belirtilmemiş</option>
        <option value="2">Tüm Hakları Saklıdır</option>
        <option value="3">Tüm Hakları Herkese Açık</option>
        <option value="4">Creative Commons (CC) İsnadı</option>
        <option value="5">(CC) Atıf-Gayriticari</option>
        <option value="6">(CC) Atıf-Gayriticari-Türetilemez</option>
        <option value="7">(CC) Attrib. NonComm. Sürümleri ile</option>
        <option value="8">(CC) Atıf-LisanDevam</option>
        <option value="9">(CC) Atıf-Türetilemez</option>
      </select>
    </div>
  </div>
);

// ContentTable bileşeninde bir değişiklik yok.
const ContentTable = ({
  chapters,
  handleSectionClick,
  showDeleteModal,
  closeDeleteModal,
  handleDeleteChapter,
  openDeleteModal,
}) => (
  <div className="content-table">
    <button className="add-section" onClick={() => handleSectionClick({ title: 'Yeni Bölüm', chapter_id: null })}>
      + Yeni Bölüm
    </button>
    {chapters.map((chapter) => (
      <div key={chapter.chapter_id} className="section-item">
        <div className="section-content">
          <div className="section-header" onClick={() => handleSectionClick(chapter)}>
            <h4 className="section-title">{chapter.title}</h4>
            <span className="section-date">{new Date(chapter.created_at).toLocaleDateString('tr-TR')}</span>
          </div>
          <div className="section-stats">
            <div className="stat-item">
              <FaEye className="stat-icon" />
              <span>{chapter.views}</span>
            </div>
            <div className="stat-item">
              <FaHeart className="stat-icon" />
              <span>{chapter.likes}</span>
            </div>
            <div className="stat-item">
              <FaComment className="stat-icon" />
              <span>{chapter.comments}</span>
            </div>
            <button
              className="delete-button"
              onClick={(e) => {
                e.stopPropagation();
                openDeleteModal(chapter.chapter_id);
              }}
              aria-label="Bölümü sil"
            >
              <FaTrash />
            </button>
          </div>
        </div>
      </div>
    ))}

    {showDeleteModal && (
      <div className="modal-overlay">
        <div className="modal-content">
          <h3>Bölümü Sil</h3>
          <p>Bu bölümü silmek istediğinize emin misiniz?</p>
          <div className="modal-actions">
            <button className="modal-cancel" onClick={closeDeleteModal}>
              İptal
            </button>
            <button className="modal-confirm" onClick={handleDeleteChapter}>
              Sil
            </button>
          </div>
        </div>
      </div>
    )}
  </div>
);


function StoryDetails() {
  const navigate = useNavigate();
  const { storyId } = useParams();
  const fileInputRef = useRef(null);

  const [title, setTitle] = useState('İsimsiz Hikaye');
  const [description, setDescription] = useState('');
  const [coverImage, setCoverImage] = useState(null);
  const [coverFile, setCoverFile] = useState(null);
  const [category, setCategory] = useState('');
  const [isPublished, setIsPublished] = useState(false);
  // DÜZELTME: Copyright state'i artık sayısal bir ID tutuyor. 
  // Varsayılan olarak "Tüm Hakları Saklıdır" (ID: 2) ayarlandı.
  const [copyright, setCopyright] = useState(2);
  const [isMatureContent, setIsMatureContent] = useState(false);
  const [chapters, setChapters] = useState([]);
  const [activeTab, setActiveTab] = useState('details');
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [chapterToDelete, setChapterToDelete] = useState(null);
  const [isMobileView, setIsMobileView] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth <= 768);
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    const fetchStoryDetails = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await api.get(`/story-details/${storyId}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        const { storyDetails, chapters } = response.data;

        chapters.sort((a, b) => a.chapter_number - b.chapter_number);

        setTitle(storyDetails.title);
        setDescription(storyDetails.description);
        setCoverImage(getBookCoverUrl(storyDetails.cover_image_url));
        setCategory(storyDetails.category_id);
        // Bu satır artık doğru çalışacak çünkü `copyright` state'i sayı bekliyor.
        setCopyright(storyDetails.telif_id);
        setIsPublished(storyDetails.is_published);
        setIsMatureContent(storyDetails.is_mature_content);
        setChapters(chapters);
      } catch (error) {
        console.error('Hikaye detayları getirilirken hata oluştu:', error);
      }
    };

    fetchStoryDetails();
  }, [storyId]);

  const handleCancel = () => {
    navigate(-1);
  };

  const handleCoverImageChange = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      setCoverFile(file);
      setCoverImage(URL.createObjectURL(file));
    }
  };

  const openFilePicker = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleSave = async () => {
    try {
      const token = localStorage.getItem('token');
      const formData = new FormData();
      formData.append('title', title);
      formData.append('description', description);
      formData.append('category_id', category);
      // 'copyright' artık doğru sayısal ID'yi içerdiği için bu satır doğru çalışacak.
      formData.append('telif_id', copyright);
      formData.append('is_published', isPublished);
      formData.append('is_mature_content', isMatureContent);

      if (coverFile) {
        formData.append('cover', coverFile);
      }

      await api.put(`/story-details/${storyId}`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      });

      navigate('/my-stories');
    } catch (error) {
      console.error('Hikaye kaydedilirken hata oluştu:', error);
    }
  };

  const openDeleteModal = (chapterId) => {
    setChapterToDelete(chapterId);
    setShowDeleteModal(true);
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
    setChapterToDelete(null);
  };

  const handleDeleteChapter = async () => {
    if (chapterToDelete !== null) {
      try {
        const token = localStorage.getItem('token');
        await api.delete(`/story-details/chapters/${chapterToDelete}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setChapters(chapters.filter(chapter => chapter.chapter_id !== chapterToDelete));
        closeDeleteModal();
      } catch (error) {
        console.error('Bölüm silinirken hata oluştu:', error);
        closeDeleteModal();
      }
    }
  };

  const handleSectionClick = (chapter) => {
    navigate('/edit-story', {
      state: {
        sectionTitle: chapter.title,
        bookId: storyId,
        chapterId: chapter.chapter_id
      }
    });
  };

  const storyFormProps = {
    title, setTitle, description, setDescription, category, setCategory,
    isMatureContent, setIsMatureContent, copyright, setCopyright
  };

  const contentTableProps = {
    chapters, handleSectionClick, showDeleteModal, closeDeleteModal,
    handleDeleteChapter, openDeleteModal
  };

  return (
    <div className="story-details-page">
      <div className="page-header">
        <button onClick={handleCancel} className="back-button" aria-label="Geri">
          ←
        </button>
        <h1 className="page-title">{title || 'İsimsiz Hikaye'}</h1>
        <div className="header-actions">
          <button onClick={handleCancel} className="cancel-btn">
            İptal
          </button>
          <button onClick={handleSave} className="save-btn">
            Kaydet
          </button>
        </div>
      </div>

      <div className="page-content">
        <div className="story-layout">
          <div className="cover-section">
            <div className="cover-container" onClick={openFilePicker}>
              {coverImage ? (
                <img src={coverImage} alt="Hikaye kapağı" className="cover-image" />
              ) : (
                <div className="cover-placeholder">
                  <div className="upload-icon">📚</div>
                  <span>Kapak Ekle</span>
                </div>
              )}
              <input
                type="file"
                onChange={handleCoverImageChange}
                accept="image/*"
                ref={fileInputRef}
                className="file-input"
              />
            </div>
          </div>

          <div className="content-section">
            {!isMobileView ? (
              <>
                <div className="tab-navigation">
                  <button
                    onClick={() => setActiveTab('details')}
                    className={`tab-button ${activeTab === 'details' ? 'active' : ''}`}
                  >
                    Hikaye Detayları
                  </button>
                  <button
                    onClick={() => setActiveTab('contents')}
                    className={`tab-button ${activeTab === 'contents' ? 'active' : ''}`}
                  >
                    İçindekiler
                  </button>
                </div>

                <div className="tab-content">
                  {activeTab === 'details' ? <StoryForm {...storyFormProps} /> : <ContentTable {...contentTableProps} />}
                </div>
              </>
            ) : (
              <div className="mobile-layout">
                <div className="mobile-section">
                  <h2 className="section-title">Hikaye Detayları</h2>
                  <StoryForm {...storyFormProps} />
                </div>

                <div className="mobile-section">
                  <h2 className="section-title">İçindekiler</h2>
                  <ContentTable {...contentTableProps} />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default StoryDetails;
